import { HomePage } from "./../home/home";
import { PlazaOverviewMovementPage } from "./../plaza-overview-movement/plaza-overview-movement";
import { PlazaOverviewPlazamapPage } from "./../plaza-overview-plazamap/plaza-overview-plazamap";
import { PlazaOverviewCashPage } from "./../plaza-overview-cash/plaza-overview-cash";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Storage } from "@ionic/storage";

@IonicPage()
@Component({
  selector: "page-plaza-overview",
  templateUrl: "plaza-overview.html",
})
export class PlazaOverviewPage {
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
    // console.log('ionViewDidLoad PlazaOverviewPage');
  }

  backPage() {
    this.navCtrl.setRoot(HomePage);
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  cash() {
    this.navCtrl.push(PlazaOverviewCashPage);
  }

  plazamap() {
    this.navCtrl.push(PlazaOverviewPlazamapPage);
  }

  movement() {
    this.navCtrl.push(PlazaOverviewMovementPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-overview/plaza-overview.ts